import React, { Component } from 'react'
import App from './App'
import AnalyticsManager from './App/analytics/manager';
import ReactGAChannel from './App/analytics/ReactGAChannel';

AnalyticsManager.registerChannel(new ReactGAChannel('GTM-NG2HVXW7'));

class Client extends React.Component {
  render() {
    return <App {...this.props} />
  }
}

export default Client
